export const PAYMENTS_TYPES = {
  card: 1,
  cashApp: 2,
  cashAppBitcoin: 17,
  paypalPYUSD: 19,
  cashAppUSDC: 21
}
